import { Component, OnInit,Input,ViewChild} from '@angular/core';

import { InterfaceElement} from '../../model/asd/asd-properties/asd-ie/asd-interfaceElement';

declare var google: any;

@Component({
  selector: 'app-html-map',
  templateUrl: './html-map.component.html',
  styleUrls: ['./html-map.component.css']
})

export class HtmlMapComponent implements OnInit {

  @Input() ieListType : InterfaceElement = new InterfaceElement();
  
  public map = null ;
  public latitude : number = 24.860966; // default value set for 'Karachi/Pakistan'
  public longitude : number = 66.990501;
  public city : string;
  public country : string;

  constructor() { }
  ngDoCheck(){
      if(this.map != null){
         google.maps.event.trigger(this.map, 'resize');
         this.map.setCenter(new google.maps.LatLng( this.latitude, this.longitude));
         new google.maps.Marker({
            position: {lat: this.latitude, lng: this.longitude},
            map: this.map
         });
     }
  }

  ngOnInit() {
   
    if(this.ieListType.CustomizeOptions!= null && this.ieListType.CustomizeOptions.DisplayType == 'map'){
      let cols = [];
      if(this.ieListType.EntityList.RowItems.length > 0){
        cols = this.ieListType.EntityList.RowItems[0].ColItems;
      }
      for(let c of cols){
        if(c.Name == 'Latitude'){
          this.latitude = c.Value;
        }
        else if(c.Name == 'Longitude'){
          this.longitude = c.Value;
        }
        else if(c.Name == 'City'){
          this.city = c.Value;
        }
        else if(c.Name == 'Land'){
          this.country = c.Value
        }
      }
   
     
      var map = new google.maps.Map(document.getElementById('map'), {
          zoom: 11,
          center: {lat: this.latitude, lng: this.longitude}
        });
      var marker = new google.maps.Marker({
          position: {lat: this.latitude, lng: this.longitude},
          title:this.city+','+this.country
       });
       marker.setMap(map);
     }
      
   }
}
